// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1Qu2J","title":"ClientInsurance_title__3EKhE","itemText":"ClientInsurance_itemText__2ywfc"};